import { render, staticRenderFns } from "./payDia.vue?vue&type=template&id=70e3fd36&scoped=true&"
import script from "./payDia.vue?vue&type=script&lang=js&"
export * from "./payDia.vue?vue&type=script&lang=js&"
import style0 from "./payDia.vue?vue&type=style&index=0&id=70e3fd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e3fd36",
  null
  
)

export default component.exports